import React, { useRef, useState } from 'react';
import Button from '@components/Button';
import {IProps, IState} from './types';
import * as S from './styles';
const uuid = require('react-uuid');

const Upload:React.FC<IProps> = (props) => {
    let fileInputRef = useRef<HTMLInputElement>(null)

    const [dragging, setDragging] = useState(false)
    
    const ondrop = (e: any) => {
      setDragging(false)
      if (e.dataTransfer && e.dataTransfer.files.length > 0) {
        validateFiles(e.dataTransfer.files);
      }
      e.target.value = '';  
    }

    const onInputFileChange = (e: any) => {
      if (fileInputRef.current) {
        validateFiles((fileInputRef.current as any).files);
      }
      e.target.value = '';
    }

    const validateFiles = (array:any) => {
      // TODO Validate 15 files or less and 800 mbs
      if (props.files.length + array.length > 15) {
        props.handleWarningScreen(
          true, "More than 15 files",
          "You are only able to upload up to 15 files at a time. Please try again with 15 or less files per upload.",
          "", undefined, "OKAY", "More than 15 files", []
        );
      } else {
        props.setFiles([...props.files, ...convertToArray(array)]);
      }
    }

    const convertToArray = (filesInput: any) => {
      let files: any[] = [];
      let repeatedFiles: any[] = [];
      let heavyFiles: any[] = [];
      for(let x = 0; x < filesInput.length; x++) {
        if (filesInput[x].size < 838860800) {
          const index = props.files.findIndex((f) => f.file.name === filesInput[x].name);
          if (index === -1) {
            files = [...files, {id: uuid(), file: filesInput[x]}];
          } else {
            repeatedFiles = [...repeatedFiles, filesInput[x].name];
          }
        } else {
          heavyFiles = [...heavyFiles, filesInput[x].name];
        }
      }
      if (repeatedFiles.length > 0) {
        props.handleWarningScreen(
          true, "Repeated File Name",
          `You have two files with the same name. Please change one of them so that every file has a unique name. `,
          "", undefined, "OKAY", "No two templates can share same name", [...repeatedFiles]
        );
      }
      if (heavyFiles.length > 0) {
        props.handleWarningScreen(
          true, "File over 800MB",
          `You are only able to upload up to files that do not exceed 800MB. Please try again with a smaller file.`,
          "", undefined, "OKAY", "File more than 200MB", [...heavyFiles]
        );
      }
      return files;
    }

    return (
        <S.Root >
            <S.Title>Upload</S.Title>
            <S.Box 
              dragging={dragging}
              onDrop={(e) => {
                e.stopPropagation();
                e.preventDefault();
                ondrop(e);
              }}
              onDragOver={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setDragging(true);
              }}
              onDragExit={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setDragging(false);
              }}
              onDragLeave={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setDragging(false);
              }}
              onDragEnd={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setDragging(false);
              }}
              >
              <Button
                  icon="add"
                  iconStyle={{fillColor: "#ff7319"}}
                  label="PSD File"
                  style={{hoverBackgroundColor: "#fdefe7", backgroundColor: "transparent", border: "1px solid #ff7319", maxWidth: 142, minWidth: 142, maxHeight: 35}}
                  labelStyle={{color: "#ff7319"}}
                  onClick={() => fileInputRef.current ? (fileInputRef.current as any).click() : undefined}
              />
              <input ref={fileInputRef} id="fileInput" type="file" style={{display: "none"}} onChange={onInputFileChange} accept=".psd" multiple={true}/>
              <S.Text>Upload a file from your device or drag and drop files here</S.Text>
            </S.Box>
        </S.Root >
    );
}

export default Upload;